export const esAdviser = {
  'adviser.accessDescription': 'Vuelve a intentarlo cuando recuperes conexión.',
  'adviser.accessError': 'No pudimos verificar tu acceso a Adviser',
  'adviser.carouselCount': '{current} de {total}',
  'adviser.description': 'Analizamos tu plan para convertir números en decisiones claras.',
  'adviser.financialHealth': 'Salud financiera',
  'adviser.insightCritical': 'Crítico',
  'adviser.insightGood': 'Fortaleza',
  'adviser.insightInfo': 'Oportunidad',
  'adviser.insightWarning': 'Atención',
  'adviser.lockedDescription':
    'Desbloquea escenarios de protección, crecimiento y alertas por wallet con Premium.',
  'adviser.lockedTitle': 'Una lectura más profunda de tu plan, {name}.',
  'adviser.mode': 'Escenario del Adviser',
  'adviser.modeGrowth': 'Crecimiento',
  'adviser.modeGrowthDescription': 'Ahorro y oportunidades',
  'adviser.modeProtection': 'Protección',
  'adviser.modeProtectionDescription': 'Riesgos y respaldo',
  'adviser.modeStandard': 'Estándar',
  'adviser.modeStandardDescription': 'Balance general',
  'adviser.nextInsight': 'Insight siguiente',
  'adviser.openCalendar': 'Ver calendario',
  'adviser.previousInsight': 'Insight anterior',
  'adviser.scoreLabel': 'Score de salud {score} de 100',
  'adviser.unlock': 'Ver opciones Premium',
  'adviser.showLess': 'Mostrar menos',
  'adviser.viewAnalysis': 'Ver análisis completo',
} as const;

export const enAdviser: Record<keyof typeof esAdviser, string> = {
  'adviser.accessDescription': 'Try again when your connection is restored.',
  'adviser.accessError': 'We could not verify your Adviser access',
  'adviser.carouselCount': '{current} of {total}',
  'adviser.description': 'We analyze your plan to turn numbers into clear decisions.',
  'adviser.financialHealth': 'Financial health',
  'adviser.insightCritical': 'Critical',
  'adviser.insightGood': 'Strength',
  'adviser.insightInfo': 'Opportunity',
  'adviser.insightWarning': 'Attention',
  'adviser.lockedDescription':
    'Unlock protection and growth scenarios plus wallet alerts with Premium.',
  'adviser.lockedTitle': 'A deeper reading of your plan, {name}.',
  'adviser.mode': 'Adviser scenario',
  'adviser.modeGrowth': 'Growth',
  'adviser.modeGrowthDescription': 'Savings and opportunities',
  'adviser.modeProtection': 'Protection',
  'adviser.modeProtectionDescription': 'Risks and safety net',
  'adviser.modeStandard': 'Standard',
  'adviser.modeStandardDescription': 'Overall balance',
  'adviser.nextInsight': 'Next insight',
  'adviser.openCalendar': 'View calendar',
  'adviser.previousInsight': 'Previous insight',
  'adviser.scoreLabel': 'Health score {score} out of 100',
  'adviser.unlock': 'View Premium options',
  'adviser.showLess': 'Show less',
  'adviser.viewAnalysis': 'View full analysis',
};
